import { useEffect } from "react";

const SITE = "https://evoexhibitions.com";

// Zero-dependency SEO: sets title, description, canonical, OG & Twitter tags.
export const SEO = ({ title, description, path = "/", image }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image || `${SITE}/apple-touch-icon.png`;
    if (title) document.title = title;

    const upsert = (selector, create, value, isHref) => {
      let el = document.head.querySelector(selector);
      if (!el) { el = create(); document.head.appendChild(el); }
      el.setAttribute(isHref ? "href" : "content", value);
    };

    upsert('meta[name="description"]', () => { const m = document.createElement("meta"); m.setAttribute("name", "description"); return m; }, description);
    upsert('link[rel="canonical"]', () => { const l = document.createElement("link"); l.setAttribute("rel", "canonical"); return l; }, url, true);

    const og = (p, c) => upsert(`meta[property="${p}"]`, () => { const m = document.createElement("meta"); m.setAttribute("property", p); return m; }, c);
    og("og:type", "website"); og("og:site_name", "EVO Exhibitions");
    og("og:title", title); og("og:description", description); og("og:url", url); og("og:image", img);

    const tw = (n, c) => upsert(`meta[name="${n}"]`, () => { const m = document.createElement("meta"); m.setAttribute("name", n); return m; }, c);
    tw("twitter:card", "summary_large_image"); tw("twitter:title", title); tw("twitter:description", description); tw("twitter:image", img);
  }, [title, description, path, image]);

  return null;
};
